import { createContext } from 'react';

export type ApprovalRolesCtx = {
  showApprovalRolesSuccess: boolean;
  showApprovalRolesErrorAlert: boolean;
  approvalRolesError: string;
};

const ApprovalRolesDialogueContext = createContext<ApprovalRolesCtx>({
  showApprovalRolesSuccess: false,
  showApprovalRolesErrorAlert: false,
  approvalRolesError: '',
});

export default ApprovalRolesDialogueContext;
